// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"shared_resetButton__lfUqt","popoverButton":"shared_popoverButton__3xh83"};